const o={asChild:{type:"boolean"}};export{o as asChildPropDef};
//# sourceMappingURL=as-child.prop.js.map
